export const trCountingBricks = {
	DE: 'Zähle Steine...',
	EN: 'Counting bricks...',
	FR: 'Compter les briques...',
};
